import React, { useState } from "react";
import {
  Button,
  Tooltip,
  Avatar,
  Box,
  Stack,
  Typography,
  IconButton,
  ButtonGroup,
  CardContent,
  CardActions,
  Badge,
  styled,
  Grid,
  Card,
  Popover,
} from "@mui/material";
import axios from "axios";
import {
  ArrowsMerge,
  Eye,
  Numpad,
  Pause,
  PauseCircle,
  SpeakerHigh,
  SpeakerSimpleX,
} from "@phosphor-icons/react";
import { BaseUrl, VoiceDomainName } from "../../Container/BaseUrl/BaseUrl";
import { BiTransfer, BiTransferAlt } from "react-icons/bi";
import { PiPhoneTransferFill } from "react-icons/pi";
import { RiShareForwardLine, RiUserAddLine } from "react-icons/ri";
import { MdCallEnd } from "react-icons/md";
import NoSelectContact from "../../Assets/images/svg/No-interactions.svg";
import { FaRegUser, FaUsers } from "react-icons/fa";
import "./callmoduleassets/AWL-min/awl.min.js";
import { connect } from "react-redux";
import {
  setagentDialedNumber,
  muteCall,
  unMuteCall,
  getAvailableAgentList,
  convertBarginCallToMainCall,
  setCallList,
  setIsBarginCall,
  ConsultedHoldCall,
} from "../../Redux/Actions/actions.js";
import { DummyReport } from "../Utils/Call-utils/call-utils.js";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle.js";
import SdkCallScreen2 from "./SdkCallScreen2.jsx";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const StyledBadge2 = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#E91E63",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const mapStateToProps = (state) => {
  return {
    callList: state.voice.callList,
    dailedNumberInc: state.voice.dailedNumberInc,
    agentDialedNumber: state.voice.agentDialedNumber,
    contactId: state.voice.contactId,
    consultedContactId: state.voice.consultedContactId,
    voicePlatForm: state.voice.voicePlatForm,
    webRTC: state.voice.webRTC,
    VoiceEndchatModalDialog: state.voice.VoiceEndchatModalDialog,
    DropDownAgentList: state.contactListData.DropDownAgentList,
    cli: state.voice.cli,
    isBarginCall: state.voice.isBarginCall,
  };
};

const Sdk = (props) => {
  const { callObj2, callmap, stopwatch1, stopwatch2, aesSocket } = props;
  const basedOnRole = JSON.parse(localStorage.getItem("tokenAgent"));
  const agentLoginTerminalId = localStorage.getItem("agentLoginTerminalId");
  const [Numbercopyed, setNumbercopyed] = useState("Copy");
  const [availableSupervisor, setAvailableSupervisor] = useState([]);
  // const [isBarginCall, setIsBarginCall] = useState(false);
  const [agentNumber, setagentNumber] = useState("");
  const [consultAgentBox, setConsultAgentBox] = useState(null);
  const consultAgentopen = Boolean(consultAgentBox);
  const consultAgentId = consultAgentopen ? "simple-popover" : undefined;

  const [consultSupervisorBox, setConsultSupervisorBox] = useState(null);
  const consultSupervisoropen = Boolean(consultSupervisorBox);
  const consultSupervisorId = consultSupervisoropen
    ? "simple-popover"
    : undefined;

  const getAvailableSupervisor = async () => {
    const access_token = localStorage.getItem("access_token");
    await axios
      .post(
        BaseUrl + "/users/listSupervisor",
        {},
        {
          headers: {
            Authorization: "Bearer " + access_token,
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          setAvailableSupervisor(res.data.data);
        } else {
          setAvailableSupervisor([]);
        }
      })
      .catch((err) => {});
  };
  const hold_call = async (contactId, callType) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      await axios
        .post(
          AvcUrl + `/voice/terminal/${agentLoginTerminalId}/hold/` + contactId,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status == "OK") {
            DummyReport("hold_call", {
              type:
                callType == "main"
                  ? ""
                  : "Transfer_Conferance_Call_unhold_call",
              contactId: contactId,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "ACR") {
      props.cli.doHold(contactId);
    } else if (props.voicePlatForm == "AES") {
      const RegDetails = {
        Event: "Hold",
        Extension: JSON.parse(localStorage.getItem("CallerId")),
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const unhold_call = async (contactId, callType) => {
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      let AvcUrl = localStorage.getItem("AvcUrl");
      await axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/unhold/${contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status == "OK") {
            DummyReport("unhold_call", {
              type:
                callType == "main"
                  ? ""
                  : "Transfer_Conferance_Call_unhold_call",
              contactId: contactId,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "ACR") {
      props.cli.doUnHold(contactId);
    } else if (props.voicePlatForm == "AES") {
      const RegDetails = {
        Event: "RetrieveCall",
        Extension: JSON.parse(localStorage.getItem("CallerId")),
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const Consult_agent = async (agentNumber) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    const contactId = JSON.parse(localStorage.getItem("callList"))[0].contactId;
    if (agentLoginTerminalId == agentNumber) {
      return alert("Don't Enter Same Extension Number You LoggedIn With");
    }
    if (agentNumber == "") {
      return alert("Please Enter Valied Number");
    }
    props.setagentDialedNumber(agentNumber);
    localStorage.setItem("consultedDialedNumber", agentNumber);
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      await axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/conference/${agentNumber}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          if (res.data.status == "OK") {
            props.ConsultedHoldCall({ contactId: contactId });
          } else {
            toast.error("Something went wrong", toaststyle);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "ACR") {
      callObj2.current = props.cli.makeCall(props.agentDialedNumber, "audio");
      if (callObj2.current !== null) {
        console.log("Second Call is Assigned to callObj2 successfully");
        callmap.current[callObj2.current.getCallId()] = callObj2.current;
      } else {
        alert("Error! Cannot make calls, try after some time");
      }
    } else if (props.voicePlatForm == "AES") {
      var RegDetails = {
        Event: "Conference",
        Extension: agentNumber,
        ActiveCallid: JSON.parse(localStorage.getItem("CallerId")),
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const Complete_Transfer = (contactId) => {
    const consultedContactId = localStorage.getItem("consultedContactId");
    const client = JSON.parse(localStorage.getItem("client"));
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/transfer/complete/${consultedContactId}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          console.log("res", res);
          if (res.data.status == "OK") {
            DummyReport("completeTransfer", {
              contactId: contactId,
              consultedId: consultedContactId,
              chatsessionid: client.chat_session_id,
            });
            tranferConferanceUpdate(consultedContactId, client.phonenumber);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "ACR") {
    }
  };
  const Blind_Transfer_Complete = async (call) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      await axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/conference/${call.surveyOptForwardNumber}/${call.contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then(async (res) => {
          let consultedContactId = res.data.data.contactId;
          if (res.data.status == "OK") {
            axios
              .post(
                `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/transfer/complete/${consultedContactId}/${call.contactId}`,
                {},
                {
                  headers: {
                    ssoToken: localStorage.getItem("ssoToken"),
                  },
                }
              )
              .then((res) => {
                if (res.data.status == "OK") {
                  // DummyReport("completeTransfer", {
                  //   contactId: contactId,
                  //   consultedId: consultedContactId,
                  //   chatsessionid: call.chat_session_id,
                  //   transfer_to: call.surveyOptForwardNumber,
                  // });
                  // tranferConferanceUpdate(
                  //   consultedContactId,
                  //   call.phone
                  // );
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } else {
            toast.error("Something went wrong", toaststyle);
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      var RegDetails = {
        Event: "Transfer",
        Extension: agentNumber,
        ActiveCallid: JSON.parse(localStorage.getItem("CallerId")),
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const Complete_Conferance = (contactId) => {
    const consultedContactId = localStorage.getItem("consultedContactId");
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      axios
        .post(
          `${AvcUrl}/voice/terminal/${agentLoginTerminalId}/conference/complete/${consultedContactId}/${contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            DummyReport("completeconference", {
              contactId: contactId,
              consultedId: consultedContactId,
              chatsessionid: JSON.parse(localStorage.getItem("client"))
                .chat_session_id,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "ACR") {
      return;
    }
  };
  const bargin_Call = (call) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/bargein/sip:${agentLoginTerminalId}@${VoiceDomainName}/${call.contactId}`,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          props.convertBarginCallToMainCall(call);
        })
        .catch((err) => {});
    } else if (props.voicePlatForm == "AES") {
      const extensionNum = JSON.parse(localStorage.getItem("AvayaUsername"));
      var RegDetails = {
        Event: "SOActivate",
        ObserverDeviceId: extensionNum,
        ObserveeDeviceId: localStorage.getItem("observeAgentList").callerId,
        SOActivateConnState: 12,
        ObserveeLocationVDN: "talk listen mode",
      };
      aesSocket.send(JSON.stringify(RegDetails));
    }
  };
  const end_call = async (contactId, callType) => {
    let AvcUrl = localStorage.getItem("AvcUrl");
    if (props.voicePlatForm == "AACC" || props.voicePlatForm == "ACCS") {
      await axios
        .post(
          AvcUrl +
            `/voice/terminal/${agentLoginTerminalId}/disconnect/` +
            contactId,
          {},
          {
            headers: {
              ssoToken: localStorage.getItem("ssoToken"),
            },
          }
        )
        .then((res) => {
          if (res.data.status == "OK") {
            localStorage.setItem("callCutByAgent", "true");
          } else {
            props.setCallList([]);
            localStorage.setItem("callList", JSON.stringify([]));
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else if (props.voicePlatForm == "AES") {
      const extensionNum = JSON.parse(localStorage.getItem("AvayaUsername"));
      if (props.isBarginCall) {
        const RegDetails = {
          Event: "SODeActivate",
          Extension: extensionNum,
        };
        aesSocket.send(JSON.stringify(RegDetails));
        props.setIsBarginCall(false);
      } else {
        const RegDetails = {
          Event: "Disconnect",
          Extension: JSON.parse(localStorage.getItem("CallerId")),
        };
        aesSocket.send(JSON.stringify(RegDetails));
      }
    }
  };
  const tranferConferanceUpdate = (contactId, phonenumber) => {
    axios
      .post(
        BaseUrl + "/users/voicetransferupdate",
        {
          voice_contactId: contactId,
          phonenumber,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantid: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        localStorage.removeItem("transfercontactId");
      });
  };

  return (
    <>
      <Box className="main-call-box">
        {props.callList.length > 0 ? (
          props.callList.map((call) => {
            if (call.callType == "ConsultConference") {
              return (
                <SdkCallScreen2
                  call={call}
                  stopwatch2={stopwatch2}
                  end_call={end_call}
                  hold_call={hold_call}
                  unhold_call={unhold_call}
                />
              );
            } else {
              return (
                <Card
                  className="mb-2"
                  sx={{
                    boxShadow:
                      call.Bargin == true
                        ? "0px 0px 4px 0px rgb(199 79 221), 0px 0px 9px 0px rgb(206 117 225 / 57%), 0px 1px 3px 0px rgb(211 157 237 / 73%)"
                        : "rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px",
                  }}
                >
                  <CardContent className="p-2">
                    <Grid container>
                      <Grid item md={2}>
                        <Avatar
                          className="box-inset2 bgs mt-1"
                          sx={{
                            width: "50px",
                            height: "50px",
                            fontSize: "16px",
                          }}
                        >
                          {call.inConferance ? (
                            <FaUsers size={30} />
                          ) : (
                            <FaRegUser size={22} />
                          )}
                        </Avatar>
                      </Grid>
                      <Grid item md={10}>
                        <Grid item md={12}>
                          <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                          >
                            <Grid
                              item
                              md={7}
                              className="ps-1"
                              container
                              direction="column"
                              justifyContent="flex-start"
                              alignItems="flex-start"
                              sx={{ minWidth: "0", width: "148px" }}
                            >
                              <Tooltip
                                title={Numbercopyed}
                                arrow
                                placement="top"
                              >
                                <Typography
                                  noWrap
                                  onClick={() => {
                                    navigator.clipboard.writeText(
                                      localStorage.getItem("incomingNumber")
                                    );
                                    setNumbercopyed("Copied");
                                    setTimeout(() => {
                                      setNumbercopyed("Copy");
                                    }, 3000);
                                  }}
                                  variant="h6"
                                  className="textp fs-16 fw-bold"
                                  sx={{
                                    display: "block",
                                    width: "148px",
                                    minWidth: "0",
                                  }}
                                >
                                  {call.phone}
                                </Typography>
                              </Tooltip>

                              {call.inConference ? (
                                <Typography
                                  noWrap
                                  variant="caption"
                                  display="block"
                                  className="text-primary fs-10"
                                  sx={{ width: "120px", minWidth: "0" }}
                                >
                                  Conference...
                                </Typography>
                              ) : (
                                <></>
                              )}

                              <Typography
                                noWrap
                                variant="caption"
                                display="block"
                                className="text-primary"
                                sx={{ width: "120px", minWidth: "0",
                                 textTransform:'capitalize',
                                 fontWeight:800,
                                 fontSize:'12px'
                                 }}
                              >
                                {call.skillSet ? call.skillSet : ""}
                              </Typography>
                              {JSON.parse(
                                localStorage.getItem("permission")
                              ).map((module) => {
                                if (module.moduleName === "INTERACTION") {
                                  const value = module.screen.some(
                                    (item) =>
                                      item.screenId === "IVR_SURVEY" &&
                                      item.read &&
                                      item.write
                                  );

                                  if (
                                    value &&
                                    call.callType == "Inbound" &&
                                    call.phone.length > 5
                                  ) {
                                    return (
                                      <Typography
                                        key={"surveyOpt"}
                                        noWrap
                                        display="block"
                                        className="text-primary "
                                        sx={{
                                          width: "120px",
                                          minWidth: "0",
                                          textTransform: "capitalize",
                                          fontWeight: 800,
                                          fontSize: "12px",
                                        }}
                                      >
                                        {call.surveyOpt
                                          ? "Survey Opt: Yes"
                                          : "Survey Opt: No"}
                                      </Typography>
                                    );
                                  } else {
                                    return null;
                                  }
                                }
                                return null;
                              })}
                            </Grid>

                            <Grid
                              item
                              md={5}
                              className="text-danger fw-bold"
                              container
                              direction="row"
                              justifyContent="flex-end"
                              alignItems="flex-end"
                              sx={{ minWidth: "0", width: "110px" }}
                            >
                              {stopwatch1.hours >= 10
                                ? stopwatch1.hours
                                : "0" + stopwatch1.hours}
                              :
                              {stopwatch1.minutes >= 10
                                ? stopwatch1.minutes
                                : "0" + stopwatch1.minutes}
                              :
                              {stopwatch1.seconds >= 10
                                ? stopwatch1.seconds
                                : "0" + stopwatch1.seconds}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                  <CardActions sx={{ background: "#f6fafe" }}>
                    <Stack
                      direction="row"
                      alignItems="center"
                      justifyContent={"start"}
                      sx={{ width: "100%" }}
                      spacing={1}
                    >
                      <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent={"start"}
                        sx={{ width: "100%" }}
                      >
                        {call.Mute && !call.Bargin && (
                          <>
                            {(() => {
                              if (
                                props.webRTC &&
                                (props.voicePlatForm == "ACCS" ||
                                  props.voicePlatForm == "AACC")
                              ) {
                                return (
                                  <Tooltip title="Mute" arrow placement="top">
                                    <IconButton
                                      aria-label="Mute"
                                      size="small"
                                      color="primary"
                                      id="Mute_call1"
                                      onClick={() => {
                                        props.muteCall(call, props.cli);
                                      }}
                                    >
                                      <SpeakerHigh size={18} />
                                    </IconButton>
                                  </Tooltip>
                                );
                              } else if (
                                !props.webRTC &&
                                props.voicePlatForm == "ACR"
                              ) {
                                return (
                                  <Tooltip title="Mute" arrow placement="top">
                                    <IconButton
                                      id="Mute_call1"
                                      aria-label="Mute"
                                      size="small"
                                      color="primary"
                                      onClick={() => {
                                        props.cli.doMute(
                                          localStorage.getItem("callId")
                                        );
                                        props.muteCall(call, props.cli);
                                      }}
                                    >
                                      <SpeakerHigh size={18} />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                            })()}
                          </>
                        )}
                        {!call.Mute && !call.Bargin && (
                          <>
                            {(() => {
                              if (
                                (props.webRTC &&
                                  props.voicePlatForm == "ACCS") ||
                                props.voicePlatForm == "AACC"
                              ) {
                                return (
                                  <Tooltip title="UnMute" arrow placement="top">
                                    <IconButton
                                      aria-label="Mute"
                                      size="small"
                                      color="primary"
                                      id="unMute_call1"
                                      onClick={() => {
                                        props.unMuteCall(call, props.cli);
                                      }}
                                    >
                                      <SpeakerSimpleX size={18} />
                                    </IconButton>
                                  </Tooltip>
                                );
                              } else if (
                                !props.webRTC &&
                                props.voicePlatForm == "ACR"
                              ) {
                                return (
                                  <Tooltip title="UnMute" arrow placement="top">
                                    <IconButton
                                      aria-label="Mute"
                                      size="small"
                                      color="primary"
                                      id="unMute_call1"
                                      onClick={() => {
                                        props.unMuteCall(call, props.cli);
                                      }}
                                    >
                                      <SpeakerSimpleX size={18} />
                                    </IconButton>
                                  </Tooltip>
                                );
                              }
                            })()}
                          </>
                        )}
                        {call.Hold && !call.Bargin && (
                          <Tooltip title="hold" arrow placement="top">
                            <IconButton
                              aria-label="Hold"
                              size="small"
                              color="primary"
                              id="hold"
                              onClick={() => {
                                hold_call(call.contactId, "mainCall");
                              }}
                            >
                              <Pause size={18} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {!call.Hold && !call.Bargin && (
                          <Tooltip title="Unhold" arrow placement="top">
                            <IconButton
                              aria-label="Hold"
                              size="small"
                              color="secondery"
                              id="unhold"
                              onClick={() => {
                                unhold_call(call.contactId, "mainCall");
                              }}
                            >
                              <PauseCircle size={18} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {call.Dialer && !call.Bargin && (
                          <Tooltip title="Consult Agent" arrow placement="top">
                            <IconButton
                              size="small"
                              color="primary"
                              id="callagent"
                              aria-describedby={consultAgentId}
                              onClick={(e) => {
                                props.getAvailableAgentList("Agent");
                                setConsultAgentBox(e.target);
                              }}
                            >
                              <Numpad size={18} />
                            </IconButton>
                          </Tooltip>
                        )}
                        {call.AssistSupervisor && !call.Bargin && (
                          <Tooltip
                            title="Assist Supervisor"
                            arrow
                            placement="top"
                          >
                            {basedOnRole.role != "Supervisor" && (
                              <IconButton
                                aria-label="Assist Supervisor"
                                size="small"
                                color="primary"
                                aria-describedby={consultSupervisorId}
                                id="call"
                                onClick={(e) => {
                                  getAvailableSupervisor();
                                  setConsultSupervisorBox(e.target);
                                }}
                              >
                                <RiUserAddLine />
                              </IconButton>
                            )}
                          </Tooltip>
                        )}
                        {call.Transfer && !call.Bargin && (
                          <Tooltip title="Transfer" arrow placement="top">
                            <IconButton
                              aria-label="Transfer Complete"
                              size="small"
                              color="primary"
                              id="call"
                              onClick={() => {
                                Complete_Transfer(call.contactId);
                              }}
                            >
                              <BiTransferAlt />
                            </IconButton>
                          </Tooltip>
                        )}
                        {call.Merge && !call.Bargin && (
                          <Tooltip title="Merge" arrow placement="top">
                            <IconButton
                              aria-label="Merge"
                              size="small"
                              color="primary"
                              id="call"
                              onClick={() => {
                                Complete_Conferance(call.contactId);
                              }}
                            >
                              <ArrowsMerge />
                            </IconButton>
                          </Tooltip>
                        )}
                        {call.Bargin && basedOnRole.role == "Supervisor" && (
                          <Tooltip title="Bargin" arrow placement="top">
                            <button
                              type="button"
                              id="call"
                              className="call-end2 border-0 d-flex justify-content-center align-items-center"
                              onClick={() => {
                                bargin_Call(call);
                              }}
                            >
                              <Eye size={18} color="#267bc9" />
                            </button>
                          </Tooltip>
                        )}
                        {call.Couch && basedOnRole.role == "Supervisor" && (
                          <Tooltip title="Bargin" arrow placement="top">
                            <button
                              type="button"
                              id="call"
                              className="call-end2 border-0 d-flex justify-content-center align-items-center"
                              onClick={() => {
                                bargin_Call(call.contactId);
                              }}
                            >
                              <Eye size={16} color="#267bc9" />
                            </button>
                          </Tooltip>
                        )}
                      </Stack>
                      {call.surveyOpt &&
                        !call.inConference &&
                        !call.Transfer &&
                        !call.Couch &&
                        !call.Bargin && (
                          <Tooltip
                            title="Transfer to Survey"
                            arrow
                            placement="top"
                          >
                            <IconButton
                              aria-label="Hold"
                              size="small"
                              color="primary"
                              id="hold"
                              onClick={() => {
                                Blind_Transfer_Complete(call);
                              }}
                            >
                              <RiShareForwardLine size={17} />
                            </IconButton>
                          </Tooltip>
                        )}
                      <Button
                        size="small"
                        color="primary"
                        className="call-btn bg-danger fs-20 ms-2"
                        sx={{ borderRadius: "4px", color: "white" }}
                        id="call"
                        onClick={() => {
                          localStorage.setItem("callCutByAgent", "true");
                          end_call(call.contactId, "mainCall");
                        }}
                      >
                        <MdCallEnd />
                      </Button>
                    </Stack>
                  </CardActions>
                </Card>
              );
            }
          })
        ) : (
          <></>
        )}

        <Popover
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "13px",
              height: "280px",
              width: "230px",
              padding: "10px",
              scrollbarWidth: "none", // Hide the scrollbar in Firefox
              "-ms-overflow-style": "none", // Hide the scrollbar in IE and Edge
              "&::-webkit-scrollbar": {
                width: "0", // Hide the scrollbar in WebKit browsers (Chrome, Safari)
              },
            },
          }}
          id={consultAgentId}
          open={consultAgentopen}
          anchorEl={consultAgentBox}
          onClose={() => {
            setConsultAgentBox(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack spacing={1} sx={{ height: "100%" }}>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Box className="d-flex">
                <input
                  type="search"
                  className="no-outline"
                  placeholder="Enter Number"
                  style={{
                    width: "120px",
                    height: "27px",
                    border: "1.5px solid #267bc9",
                    paddingLeft: "5px",
                    fontSize: "11px",
                    outline: "unset",
                    outlineOffset: "unset",
                    borderRadius: "4px",
                  }}
                  onChange={(e) => {
                    setagentNumber(e.target.value.replace(/[^\d]/, ""));
                  }}
                />
                <ButtonGroup
                  variant="contained"
                  aria-label="Basic button group"
                  className="ms-1"
                  disableElevation
                >
                  <Tooltip
                    title={
                      props.voicePlatForm == "AES"
                        ? "Make conference"
                        : "Make Call"
                    }
                    arrow
                    placement="top"
                  >
                    <Button
                      disableElevation
                      onClick={() => {
                        Consult_agent(agentNumber);
                        setConsultAgentBox(null);
                      }}
                    >
                      <BiTransfer />
                    </Button>
                  </Tooltip>
                  {props.voicePlatForm === "AES" &&
                    props.callList.some((call) => !call.inConferance) && (
                      <Tooltip title="Blind Transfer" arrow placement="top">
                        <Button
                          disableElevation
                          onClick={Blind_Transfer_Complete}
                        >
                          <PiPhoneTransferFill />
                        </Button>
                      </Tooltip>
                    )}
                </ButtonGroup>
              </Box>
            </Stack>
            <Typography
              sx={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#267bc9",
              }}
            >
              Agents
            </Typography>
            <Box
              sx={{
                overflow: "scroll",
                background: "#ffff",
                maxHeight: "200px",
                width: "100%",
                justifyContent: "flex-start",
              }}
              p={0.5}
            >
              <Stack spacing={0.5}>
                {props.DropDownAgentList.length > 0 ? (
                  props.DropDownAgentList.slice()
                    .sort((a, b) => {
                      if (
                        a.agent_status === "Available" &&
                        b.agent_status !== "Available"
                      ) {
                        return -1;
                      } else if (
                        a.agent_status !== "Available" &&
                        b.agent_status === "Available"
                      ) {
                        return 1;
                      } else {
                        return a.username.toLowerCase() <
                          b.username.toLowerCase()
                          ? -1
                          : 1;
                      }
                    })
                    .map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          cursor: "pointer",
                          padding: "4px 2px",
                          borderRadius: "7px",
                          display: "flex",
                          flexDirection: "row",
                          borderBottom: "1px solid gray",
                          justifyContent: "flex-start",
                          gap: "8px",
                          "&:hover": {
                            background: "#f6f6f6",
                          },
                        }}
                        onClick={() => {
                          setConsultAgentBox(null);
                          Consult_agent(item.CTIagentLoginTerminalId);
                        }}
                      >
                        {item.agent_status == "Available" ? (
                          <StyledBadge
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            variant="dot"
                          >
                            <Avatar
                              sx={{
                                width: "35px",
                                height: "35px",
                                fontSize: "14px",
                              }}
                              className="box-inset2"
                            >
                              {item.username.slice(0, 1).toUpperCase()}
                            </Avatar>
                          </StyledBadge>
                        ) : (
                          <StyledBadge2
                            overlap="circular"
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "right",
                            }}
                            variant="dot"
                          >
                            <Avatar
                              sx={{
                                width: "35px",
                                height: "35px",
                                fontSize: "14px",
                              }}
                              className="box-inset2"
                            >
                              {item.username.slice(0, 1).toUpperCase()}
                            </Avatar>
                          </StyledBadge2>
                        )}

                        <Stack>
                          <Typography
                            className="me-2 fs-13"
                            sx={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#615e5e",
                            }}
                            id="call"
                          >
                            {item.username ? item.username : item.firstName}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#615e5e",
                            }}
                            id="call"
                          >
                            ({item.CTIagentLoginTerminalId})
                          </Typography>
                        </Stack>
                      </Box>
                    ))
                ) : (
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    spacing={2}
                    sx={{ height: "100%", width: "100%" }}
                  >
                    <img
                      src={NoSelectContact}
                      alt="pic"
                      style={{
                        width: "7rem",
                        userSelect: "none",
                      }}
                    />
                    <h4
                      style={{
                        color: "#3BA0E1",
                        fontWeight: "600",
                        userSelect: "none",
                        fontSize: "11px",
                      }}
                    >
                      No Data found.
                    </h4>
                  </Stack>
                )}
              </Stack>
            </Box>
          </Stack>
        </Popover>

        <Popover
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "13px",
              height: "280px",
              width: "200px",
              padding: "10px",
              scrollbarWidth: "none", // Hide the scrollbar in Firefox
              "-ms-overflow-style": "none", // Hide the scrollbar in IE and Edge
              "&::-webkit-scrollbar": {
                width: "0", // Hide the scrollbar in WebKit browsers (Chrome, Safari)
              },
            },
          }}
          id={consultSupervisorId}
          open={consultSupervisoropen}
          anchorEl={consultSupervisorBox}
          onClose={() => {
            setConsultSupervisorBox(null);
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <Stack spacing={1} sx={{ height: "100%" }}>
            <Box className="border-bottom w-100 mb-2 py-1">
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: "600",
                  color: "#267bc9",
                }}
              >
                Supervisor
              </Typography>
            </Box>

            <Box
              sx={{
                overflow: "scroll",
                background: "#ffff",
                maxHeight: "200px",
                width: "100%",
                justifyContent: "flex-start",
              }}
              p={0.5}
            >
              <Stack spacing={0.5}>
                {availableSupervisor.length > 0 ? (
                  availableSupervisor
                    .slice()
                    .sort((a, b) => {
                      if (
                        a.agent_status === "Available" &&
                        b.agent_status !== "Available"
                      ) {
                        return -1;
                      } else if (
                        a.agent_status !== "Available" &&
                        b.agent_status === "Available"
                      ) {
                        return 1;
                      } else {
                        return a.username.toLowerCase() <
                          b.username.toLowerCase()
                          ? -1
                          : 1;
                      }
                    })
                    .map((item, index) => (
                      <Box
                        key={index}
                        sx={{
                          cursor: "pointer",
                          padding: "4px 2px",
                          borderRadius: "7px",
                          display: "flex",
                          flexDirection: "row",
                          borderBottom: "1px solid gray",
                          alignItems: "center",
                          gap: "8px",
                          "&:hover": {
                            background: "#f6f6f6",
                          },
                        }}
                        onClick={() => {
                          setConsultSupervisorBox(null);
                          Consult_agent(item.CTIagentLoginTerminalId);
                        }}
                      >
                        <StyledBadge
                          overlap="circular"
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          variant="dot"
                        >
                          <Avatar
                            sx={{
                              width: "35px",
                              height: "35px",
                              fontSize: "14px",
                            }}
                            className="box-inset2"
                          >
                            {item.username.slice(0, 1).toUpperCase()}
                          </Avatar>
                        </StyledBadge>

                        <Stack>
                          <Typography
                            className="me-2 fs-13"
                            sx={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#615e5e",
                            }}
                            id="call"
                          >
                            {item.username ? item.username : item.firstName}
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#615e5e",
                            }}
                            id="call"
                          >
                            ({item.CTIagentLoginTerminalId})
                          </Typography>
                        </Stack>
                      </Box>
                    ))
                ) : (
                  <Stack
                    alignItems={"center"}
                    justifyContent={"center"}
                    spacing={2}
                    sx={{ height: "100%", width: "100%" }}
                  >
                    <img
                      src={NoSelectContact}
                      alt="pic"
                      style={{
                        width: "7rem",
                        userSelect: "none",
                      }}
                    />
                    <h4
                      style={{
                        color: "#3BA0E1",
                        fontWeight: "600",
                        userSelect: "none",
                        fontSize: "11px",
                      }}
                    >
                      No Data found.
                    </h4>
                  </Stack>
                )}
              </Stack>
            </Box>
          </Stack>
        </Popover>
      </Box>
    </>
  );
};

export default connect(mapStateToProps, {
  setagentDialedNumber,
  muteCall,
  unMuteCall,
  getAvailableAgentList,
  convertBarginCallToMainCall,
  setCallList,
  setIsBarginCall,
  ConsultedHoldCall
})(Sdk);
